import { styled } from '@mui/material/styles';
import { List, ListItem, Collapse } from '@mui/material';
import { Link } from 'react-router-dom';

export const StyledList = styled(List)({
    width: '100%',
    padding: 0,
});

export const StyledListItem = styled(ListItem)<{ level?: number }>(({ theme, level = 0 }) => ({
    paddingLeft: level === 0 ? 20 : level === 1 ? 40 : 56,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    minHeight: 44,
    cursor: 'pointer',
    color: theme.palette.layout.sidebarDarkText, 
    fontSize: level === 0 ? 14 : 13,
    transition: 'all 0.15s ease-in-out',
    
    '&:hover, &.active, &.has-active-child': {
        color: theme.palette.common.white,
        '& .MuiListItemIcon-root, & .MuiListItemText-root .MuiTypography-root': {
            color: theme.palette.common.white,
        }
    },
    
    '& .MuiListItemIcon-root': {
        minWidth: 28,
        color: 'inherit',
        marginRight: 12,
    },
    
    '& .MuiListItemText-root': {
        margin: 0,
        flex: 1,
        minWidth: 0,
        '& .MuiTypography-root': {
            fontSize: 'inherit',
            color: 'inherit',
            fontWeight: 500,
        }
    },
    
    '&.menu-item .MuiListItemText-root .MuiTypography-root': {
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        hyphens: 'auto',
        whiteSpace: 'normal',
    },
    
    'body.vertical-collpsed &': level === 0 ? {
        padding: '12px 0',
        justifyContent: 'center',
        '& .MuiListItemIcon-root': {
            minWidth: 'unset',
            margin: 0,
            justifyContent: 'center',
        }
    } : {},
}));

export const StyledLink = styled(Link)({
    textDecoration: 'none',
    color: 'inherit',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    hyphens: 'auto',
    whiteSpace: 'normal',
});

export const SubMenuContainer = styled(Collapse)({
    '& .MuiList-root': {
        padding: 0,
    }
});
